module.exports = __webpack_public_path__ + "static/media/map-marker.c8050b55.svg";